module.exports = __webpack_public_path__ + "img/mine-menu-icon.0006461a.png";